import { useEffect, useState } from "react";
import Project1Layout from "../../components/projects/project1/Project1Layout";
import { useParams } from "react-router-dom";
import projectPageData from "../../helpers/projectstore";
import Project2Layout from "../../components/projects/project2/Project2Layout";
import Nav from "../../components/navbar/Nav";

export default function ProjectsPage() {
  const { id } = useParams();
  const [projectData, setProjectData] = useState({});

  useEffect(() => {
    const filteredProject =
      projectPageData?.find(
        (project) => project?.pageUrl?.toLowerCase() === id?.toLowerCase()
      ) || {};
    setProjectData(filteredProject);
  }, [id]);

  return (
    <>
      <Nav isNavSticky={true} />
      {projectData.layout === "layout1" ? (
        <Project1Layout projectData={projectData} />
      ) : (
        <Project2Layout projectData={projectData} />
      )}
    </>
  );
}
